// extracted by mini-css-extract-plugin
module.exports = {"button":"Switch_button__3mlmS","knob":"Switch_knob__IAVHQ","on":"Switch_on__3rcfl","off":"Switch_off__30HM9"};